var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightBoxed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_41_33",
    "data-name": "Component 41 \\u2013 33",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke: rgba(132,58,181,0);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3431",
    "data-name": "Rectangle 3431",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 45,
    height: 45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-round-forward",
    "data-name": "Icon ionic-md-arrow-round-forward",
    className: "cls-2",
    d: "M15.676,22.154l6.775-6.573a1.494,1.494,0,0,0,.441-1.1v-.02a1.494,1.494,0,0,0-.441-1.1L15.676,6.79a1.451,1.451,0,0,0-2.119,0,1.623,1.623,0,0,0,0,2.217l4.072,3.9H7.131a1.571,1.571,0,0,0,0,3.14h10.5l-4.072,3.9a1.623,1.623,0,0,0,0,2.217A1.456,1.456,0,0,0,15.676,22.154Z",
    transform: "translate(8.375 7.67)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBoxed);
export default __webpack_public_path__ + "static/media/arrow-right-boxed.0bf69711093a5cafa6f21806a595c19e.svg";
export { ForwardRef as ReactComponent };